"use client";

import React from "react";
import Image from "next/image";
import { useSiteSettings } from "@/hooks/useSiteSettings";

type BannerProps = {
  title: string;
  breadcrumb: React.ReactNode;
  bannerUrl?: string;
};

export default function Banner({ title, breadcrumb, bannerUrl }: BannerProps) {
  const { data: siteSettings } = useSiteSettings();

  const apiBannerUrl =
    siteSettings?.data?.background_image ??
    null;

  const src = bannerUrl ?? apiBannerUrl;

  return (
    <div
      className="relative flex flex-col justify-end px-10 py-8"
      style={{ minHeight: 200 }}
    >
      {src && (
        <Image
          src={src}
          alt=""
          fill
          priority={true}
          className="object-cover object-top"
          aria-hidden="true"
          unoptimized
        />
      )}
      <div className="relative container mx-auto max-w-7xl z-10">
        <h1 className="text-white text-5xl font-bold">{title}</h1>
        <div className="text-white mt-2">{breadcrumb}</div>
      </div>
    </div>
  );
}